import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { healthDropdownOptions } from "../../../../utility/data";
import AdminHome from "./adminHome";
import UserHome from "./home";
import {
  getAssetOverviewService,
  getFortuneService,
  getLegacyDataService,
} from "../../../../services/viewWealth";
import {
  startLoading,
  stopLoading,
} from "../../../../redux/slices/loaderSlice";
import { handleErrorRedirect } from "../../../../utility/errorRedirect";
import moment from "moment";
const Index = () => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.user);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [fortuneData, setFortuneData] = useState([]);
  const [allAssetsData, setAllAssetsData] = useState([]);
  const [leagcyData, setLeagcyData] = useState([]);

  const toast = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (role !== "admin") {
      const startDate = moment("0001-01-01").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");

      GetWealthFortuneData("ytd", startDate, endDate);
      GetWealthLegacyData("ytd", startDate, endDate);
      GetAssetOverviewData();
    }
  }, []);

  const handleIconClick = () => {
    navigate("/my-view");
  };

  const handleAddGroupClick = () => {
    navigate("/view-group");
  };

  const handleAddLegacyClick = () => {
    navigate("/view-legacy");
  };

  const handleViewWealthClick = () => {
    navigate("/wealth-view");
  };

  const assetTypeMap = {
    1: "cash",
    2: "stock",
    3: "real-estate",
    4: "luxury-asset",
    5: "company",
    6: "pension",
  };

  const handleOptionSelect = (typeId, response) => {
    const route = assetTypeMap[typeId] || "unknown";
    navigate(`/view-${route}-transaction`, {
      state: {
        id: response ?? null,
      },
    });
  };

  const GetWealthFortuneData = async (type, startDate, endDate) => {
    dispatch(startLoading());
    try {
      const response = await getFortuneService(
        type,
        startDate,
        endDate,
        accessToken
      );
      if (response.status === 200) {
        setFortuneData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      if (toast.current) {
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: err.message,
          life: 3000,
        });
      }
    } finally {
      dispatch(stopLoading());
    }
  };

  const GetWealthLegacyData = async (type, startDate, endDate) => {
      dispatch(startLoading());
      try {
        const response = await getLegacyDataService(
          type,
          startDate,
          endDate,
          accessToken
        );
        if (response.status === 200) {
          setLeagcyData(response?.data.data);
        } else {
          throw new Error("Failed to fetch user data");
        }
      } catch (err) {
        const status = err?.response?.status;
        handleErrorRedirect(status, navigate);
        if (toast.current) {
          toast.current.show({
            className: "bg-yellow-700 text-white",
            severity: "warn",
            summary: "Warning",
            detail: err.message,
            life: 3000,
          });
        }
      } finally {
        dispatch(stopLoading());
      }
    };


  const GetAssetOverviewData = async (type) => {
    dispatch(startLoading());
    try {
      const response = await getAssetOverviewService(accessToken);
      if (response.status === 200) {
        setAllAssetsData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      if (toast.current) {
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: err.message,
          life: 3000,
        });
      }
    } finally {
      dispatch(stopLoading());
    }
  };



  return (
    <div className="flex flex-col justify-center items-center h-full mt-1">
      <Toast ref={toast} />
      {role === "user" && (
        <UserHome
          handleOptionSelect={handleOptionSelect}
          healthDropdownOptions={healthDropdownOptions}
          handleAddGroupClick={handleAddGroupClick}
          handleIconClick={handleIconClick}
          handleAddLegacyClick={handleAddLegacyClick}
          handleViewWealthClick={handleViewWealthClick}
          fortuneData={fortuneData}
          allAssetsData={allAssetsData}
          leagcyData={leagcyData}
        />
      )}
      {role === "admin" && <AdminHome />}
    </div>
  );
};

export default Index;
